import { Routes, Route, Navigate } from 'react-router-dom';

import AuthRoutes from './AuthRoutes';
import PrivateRoutes from './PrivateRoutes';

import Error from '../components/pages/Error';

import Login from '../components/pages/Login';
import Schools from '../components/pages/Schools';
import UserSignUp from '../components/pages/reports/UserSignUp';
import ActiveUser from '../components/pages/reports/ActiveUser';
import UserScore from '../components/pages/reports/UserScore';
import Interview from '../components/pages/reports/Interview';
import ActiveUserDemographics from '../components/pages/reports/ActiveUserDemographics';
import UserJobs from '../components/pages/reports/UserJobs';
import CertificateAwards from '../components/pages/reports/CertificateAwards';
import UserVisits from '../components/pages/reports/UserVisits';
import PageViews from '../components/pages/reports/PageViews';

const NavigationRoutes = () => {
    return (
        <Routes>
            <Route element={<AuthRoutes />}>
                <Route path='/auth/sign-in' element={<Login />} />
            </Route>

            <Route element={<PrivateRoutes />}>
                <Route path='/' element={<Navigate to='/schools' replace />} />
                <Route path='/schools' element={<Schools />} />
                <Route path='/reports' element={<UserSignUp />} />
                <Route path='/reports/user-sign-up' element={<UserSignUp />} />
                <Route path='/reports/active-user' element={<ActiveUser />} />
                <Route path='/reports/user-scores' element={<UserScore />} />
                <Route path='/reports/interviews-completed' element={<Interview />} />
                <Route path='/reports/active-user-demographics' element={<ActiveUserDemographics />} />
                <Route path='/reports/user-jobs' element={<UserJobs />} />
                <Route path='/reports/certificate-awards' element={<CertificateAwards />} />
                <Route path='/reports/user-visits' element={<UserVisits />} />
                <Route path='/reports/page-views' element={<PageViews />} />
            </Route>

            <Route path="*" element={<Error />} />
        </Routes>
    );
};

export default NavigationRoutes;